var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu-group"},_vm._l((_vm.items),function(item,index){return _c('v-editor-group-item',{key:index,attrs:{"active":item.value === _vm.selected,"rule":item},on:{"click":_vm.onClick}},[_c(item.icon,{tag:"component"})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }